// messages.ts
// Updated to include credit note translation keys
import messages from "../../lngProvider/locales/en_US.json"

// กำหนด type จาก key ของ JSON โดยตรง
export type MessageIdType = keyof typeof messages

// ช่วยให้ values รับได้หลายชนิดที่ react-intl รองรับ
export type MessageValuesType =
    | Record<
        string,
        string | number | boolean | Date | null | undefined | React.ReactNode
    >

// แปลง JSON → { id: "..." } mapping อัตโนมัติ
export const messageMap: Record<MessageIdType, { id: MessageIdType }> =
    Object.keys(messages).reduce((acc, key) => {
        acc[key as MessageIdType] = { id: key as MessageIdType }
        return acc
    }, {} as Record<MessageIdType, { id: MessageIdType }>)
